import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import BaseDetails from 'containers/Base/BaseDetails';
import {
  toggleModal,
  createError,
  getCurrentPage,
  openDetails,
  closeDetails,
} from 'reducers/ui';
import {
  workOrderGridTableActions,
  workOrdersNS,
  workOrderSelectors,
} from '../';
import staticText from 'static/text_display.json';
import { translatedKeyValueText } from 'utils/methods/helpers';
import { isEmpty } from 'lodash';

const BaseWorkOrderDetails = ({
  id,
  cancel,
  toggleEditMode,
  toggleModal,
  editable,
  details,
  fetchWorkOrderTaskDetailsPdf,
  operationComponent: Operational,
  downloadable,
  rawDetails,
  checkCanBeEdited,
  selected,
  fetchWorkOrderTaskDetails,
  clearDetails,
  loading,
  clearDetailsID,
  openDetails,
  closeDetails,
  setWorkOrderID,
}) => {
  const [isEditable, setIsEditable] = useState(editable);
  const onDownloadClick = () => {
    fetchWorkOrderTaskDetailsPdf(id);
  };
  const pageUrl = useSelector(state => getCurrentPage(state));

  useEffect(() => {
    if (id && selected) {
      fetchWorkOrderTaskDetails({ id, dummyTaskData: selected });
      openDetails(pageUrl);
      setWorkOrderID(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (typeof checkCanBeEdited === 'function' && !isEmpty(details)) {
      setIsEditable(checkCanBeEdited({ data: details }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!isEmpty(details) && details.others.id.value]);

  const onEdit = () => {
    toggleEditMode();
    toggleModal();
  };

  const closeDetailPanel = () => {
    closeDetails(pageUrl);
    clearDetailsID();
    cancel();
    clearDetails();
  };
  return (
    <BaseDetails
      editable={isEditable}
      header={staticText.maintenance_operational_view.task.details}
      details={details}
      onEdit={onEdit}
      cancel={closeDetailPanel}
      loading={loading}
      {...(Operational && {
        operationComponent: (
          <Operational
            details={details}
            id={id}
            toggleModal={toggleModal}
            toggleEditMode={toggleEditMode}
            rawDetails={rawDetails}
            selected={selected}
          />
        ),
      })}
      editHoverText={
        details && Object.keys(details).length > 0
          ? translatedKeyValueText('edit_value_title', {
              value: details.generalInfo.taskName.value,
            })
          : staticText.maintenance_operational_view.task.details
      }
      downloadable={downloadable}
      {...(downloadable && {
        onDownloadClick: onDownloadClick,
        downloadHoverText: staticText.reporting_view.task_download,
      })}
    />
  );
};

const mapStateToProps = state => ({
  details: workOrderSelectors.getGridRowDetailsTransformed(
    state,
    getCurrentPage(state),
  ),
  rawDetails: workOrderSelectors.getDetailsTransformedRaw(state),
});

const mapDispatchToProps = dispatch => ({
  openDetails: url => dispatch(openDetails(url)),
  closeDetails: url => dispatch(closeDetails(url)),
  setWorkOrderID: id =>
    dispatch(workOrderGridTableActions.setSelectedRowID(id)),
  fetchWorkOrderTaskDetails: ({ id, dummyTaskData }) =>
    dispatch(
      workOrderGridTableActions.fetchGridRowDetails({ id, dummyTaskData }),
    ),
  fetchWorkOrderTaskDetailsPdf: id =>
    dispatch(workOrderGridTableActions.fetchGridRowDetailsPdf({ id })),
  toggleModal: () => dispatch(toggleModal(workOrdersNS)),
  createError: errorMessage => dispatch(createError(errorMessage)),
  clearDetails: () =>
    dispatch(workOrderGridTableActions.setGridRowDetails({ details: {} })),
  clearDetailsID: () =>
    dispatch(workOrderGridTableActions.setSelectedRowID(null)),
});

BaseWorkOrderDetails.propTypes = {
  id: PropTypes.string,
  cancel: PropTypes.func,
  toggleEditMode: PropTypes.func,
  toggleModal: PropTypes.func,
  editable: PropTypes.bool,
  details: PropTypes.object,
  fetchMaintainerTaskDetails: PropTypes.func,
  fetchMaintainerTaskDetailsPdf: PropTypes.func,
  fetchMaintainerTaskQr: PropTypes.func,
  createError: PropTypes.func,
  operationComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  downloadable: PropTypes.bool,
  onDownloadClick: PropTypes.func,
  rawDetails: PropTypes.object,
  checkCanBeEdited: PropTypes.func,
  selected: PropTypes.object,
  setMessage: PropTypes.func,
  resetMsg: PropTypes.func,
  fetchWorkOrderTaskDetailsPdf: PropTypes.func,
  fetchWorkOrderTaskDetails: PropTypes.func,
  clearDetails: PropTypes.func,
  loading: PropTypes.bool,
  clearDetailsID: PropTypes.func,
  openDetails: PropTypes.func,
  closeDetails: PropTypes.func,
  setWorkOrderID: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BaseWorkOrderDetails);
